import { CheckCircle, Clock, XCircle } from 'lucide-react';

interface ApprovalSummaryHeaderProps {
    approvalStatus: 'completed' | 'rejected' | 'pending';
    completedCount: number;
    totalCount: number;
    pendingCount: number;
    onCollapse: () => void;
}

const statusConfigs = {
    completed: {
        bgColor: 'bg-gradient-to-br from-green-500 to-green-600',
        icon: CheckCircle,
        text: 'อนุมัติเสร็จสิ้นแล้ว',
        badge: {
            bg: 'bg-gradient-to-r from-green-100 to-emerald-100',
            text: 'text-green-700',
            content: '✓ เสร็จสิ้น'
        }
    },
    rejected: {
        bgColor: 'bg-gradient-to-br from-red-500 to-red-600',
        icon: XCircle,
        text: 'การอนุมัติถูกปฏิเสธ',
        badge: null
    },
    pending: {
        bgColor: 'bg-gradient-to-br from-indigo-500 to-blue-600',
        icon: Clock,
        text: 'รอการอนุมัติ',
        badge: {
            bg: 'bg-gradient-to-r from-amber-100 to-orange-100',
            text: 'text-amber-700',
            content: `รออนุมัติ`
        }
    }
} as const;

const ApprovalSummaryHeader: React.FC<ApprovalSummaryHeaderProps> = ({
    approvalStatus,
    completedCount,
    totalCount,
    pendingCount,
    onCollapse
}) => {
    const config = statusConfigs[approvalStatus];
    const StatusIcon = config.icon;

    return (
        <div className="flex flex-row sm:items-center justify-between gap-2 sm:gap-0">
            <div className="flex items-center gap-2 sm:gap-3">
                <div className={`p-1.5 sm:p-2 rounded-lg shadow-md flex-shrink-0 ${config.bgColor}`}>
                    <StatusIcon className="h-4 w-4 sm:h-5 sm:w-5 text-white" />
                </div>
                <div>
                    <span className="text-sm sm:text-base font-bold text-slate-900">
                        {config.text}
                    </span>
                    <div className="text-xs sm:text-sm text-slate-600">
                        {completedCount} จาก {totalCount} ขั้นตอน
                        {approvalStatus === 'completed' && (
                            <span className="text-green-600 font-medium ml-1">✓ เสร็จสิ้น</span>
                        )}
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
                {config.badge && (
                    <span className={`hidden sm:flex text-xs ${config.badge.bg} ${config.badge.text} px-2 py-1 sm:px-3 sm:py-1.5 rounded-full font-semibold shadow-sm`}>
                        {approvalStatus === 'pending' ? `รออนุมัติ ${pendingCount}` : config.badge.content}
                    </span>
                )}
                <button
                    onClick={onCollapse}
                    className="text-xs text-slate-600 bg-slate-100 hover:bg-slate-200 px-2 py-1 sm:px-3 sm:py-1.5 rounded-lg font-medium transition-colors duration-200"
                >
                    ย่อ
                </button>
            </div>
        </div>
    );
};

export default ApprovalSummaryHeader;
